import { styled, themeGet } from '@qwealth/qcore';

export const TableHead = styled.thead`
  border-bottom: 2px solid black;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  background-color: ${themeGet('colors.gray.5')};
`;

interface tableRowProps {
  index: number;
  isVisible: boolean;
  isSelected?: boolean;
}

export const TableRowAnimated = styled.tr<tableRowProps>`
  &:nth-of-type(odd) {
    background-color: ${({ isSelected }) =>
      isSelected ? themeGet('colors.gray.2') : themeGet('colors.white')};
  }

  &:nth-of-type(even) {
    background-color: ${({ isSelected }) =>
      isSelected ? themeGet('colors.gray.2') : themeGet('colors.gray.4')};
  }

  &:hover {
    background-color: ${({ isSelected }) =>
      !isSelected ? themeGet('colors.gray.3') : themeGet('colors.gray.2')};
    cursor: pointer;
  }

  opacity: 0;
  animation: ${({ isVisible }) => (isVisible ? 'fadeInUp' : 'fadeOutDown')} 0.5s ease-out;
  animation-fill-mode: forwards;
  animation-delay: ${({ index }) => index * 0.1}s;

  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes fadeOutDown {
    from {
      opacity: 1;
      transform: translateY(0);
    }
    to {
      opacity: 0;
      transform: translateY(20px);
    }
  }
`;

interface TableRowProps2 {
  isSelected: boolean;
  isVisible: boolean;
  index: number;
}

export const TableRowAnimated2 = styled.div<TableRowProps2>`
  display: flex;
  width: 100%;

  background-color: ${({ isSelected, index }) =>
    isSelected
      ? themeGet('colors.gray.2')
      : index % 2 === 0
      ? themeGet('colors.gray.4')
      : themeGet('colors.white')};

  &:hover {
    background-color: ${({ isSelected }) =>
      !isSelected ? themeGet('colors.gray.3') : themeGet('colors.gray.2')};
    cursor: pointer;
  }

  opacity: 0;
  animation: ${({ isVisible }) => (isVisible ? 'fadeInUp' : 'fadeOutDown')} 0.5s ease-out;
  animation-fill-mode: forwards;
  animation-delay: ${({ index }) => index * 0.1}s;

  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes fadeOutDown {
    from {
      opacity: 1;
      transform: translateY(0);
    }
    to {
      opacity: 0;
      transform: translateY(20px);
    }
  }
`;

export const TableCell = styled.td`
  padding: 12px;
  border-bottom: 1px solid #eee;
`;

export const TableWrapper = styled.div`
  height: 65vh;
  overflow: auto;
  width: 100%;
  border-bottom: 1px solid #ccc;
`;

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

export const TableHeader = styled.th`
  position: sticky;
  top: 0;
  background: ${themeGet('colors.gray.3')};
  padding: 12px;
  text-align: left;
  border-bottom: 2px solid black;
`;

export const TableHeaderWrapper = styled.thead`
  border-bottom: 2px solid black;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
`;
